var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.forms
    ? _c(
        "div",
        [
          _vm._l(_vm.forms, function(form, index) {
            return form.allowModificationOfCourierAddress
              ? _c(
                  "div",
                  { staticClass: "tls-status-passback-address-card-group" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "tls-status-passback-address-card-group--slot"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "tls-status-covid-card-info" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "tls-status-covid-card-info--title tls-popup-address-name",
                                on: {
                                  click: function($event) {
                                    return _vm.toggleDropdown(form, index)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tls-link-dropdown--text" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._.get(form, "f_pers_givennames")
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm._.get(form, "f_pers_surnames")
                                        )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                !form.dropdownStatus
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "tls-link-dropdown--icon"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-chevron-down"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                form.dropdownStatus
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "tls-link-dropdown--icon"
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-chevron-up"
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tls-status-covid-card-info--body",
                                class: form.dropdownStatus ? "" : "hidden"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tls-status-passback-address-card-info-body--content"
                                  },
                                  [
                                    _c(
                                      "form",
                                      {
                                        staticClass: "tls-covid-form",
                                        attrs: {
                                          name: "editForm",
                                          role: "form",
                                          id: "form_" + form.f_id
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "vue-form-generator" },
                                          [
                                            _c(
                                              "fieldset",
                                              { staticClass: "valid" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "field-input"
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for: "house_number"
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._.get(
                                                                _vm.cmsData,
                                                                "house_number"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "field-wrap"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "wrapper"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    form.house_number,
                                                                  expression:
                                                                    "form.house_number"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                id:
                                                                  "house_number",
                                                                name:
                                                                  "house_number",
                                                                type: "text",
                                                                required:
                                                                  "required",
                                                                maxLength: "100"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  form.house_number
                                                              },
                                                              on: {
                                                                input: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      form,
                                                                      "house_number",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onFormsChanged(
                                                                      "house_number_" +
                                                                        form.f_id,
                                                                      form.house_number,
                                                                      index
                                                                    )
                                                                  }
                                                                ]
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      ref:
                                                        "house_number_" +
                                                        form.f_id,
                                                      refInFor: true,
                                                      staticClass: "hidden"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "field-input"
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: { for: "street" }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._.get(
                                                                _vm.cmsData,
                                                                "street"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "field-wrap"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "wrapper"
                                                          },
                                                          [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    form.street,
                                                                  expression:
                                                                    "form.street"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                id: "street",
                                                                name: "street",
                                                                type: "text",
                                                                required:
                                                                  "required",
                                                                maxLength: "100"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  form.street
                                                              },
                                                              on: {
                                                                input: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      form,
                                                                      "street",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onFormsChanged(
                                                                      "street_" +
                                                                        form.f_id,
                                                                      form.street,
                                                                      index
                                                                    )
                                                                  }
                                                                ]
                                                              }
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      ref:
                                                        "street_" + form.f_id,
                                                      refInFor: true,
                                                      staticClass: "hidden"
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "tls-row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "tls-form--slot field-input"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for: "city"
                                                            }
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._.get(
                                                                    _vm.cmsData,
                                                                    "city"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "field-wrap"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "wrapper"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        form.city,
                                                                      expression:
                                                                        "form.city"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    id: "city",
                                                                    name:
                                                                      "city",
                                                                    type:
                                                                      "text",
                                                                    required:
                                                                      "required",
                                                                    maxLength:
                                                                      "100"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      form.city
                                                                  },
                                                                  on: {
                                                                    input: [
                                                                      function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          form,
                                                                          "city",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                      function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onFormsChanged(
                                                                          "city_" +
                                                                            form.f_id,
                                                                          form.city,
                                                                          index
                                                                        )
                                                                      }
                                                                    ]
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("div", {
                                                          ref:
                                                            "city_" + form.f_id,
                                                          refInFor: true,
                                                          staticClass: "hidden"
                                                        })
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "tls-form--slot fl field-input"
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: {
                                                              for: "postcode"
                                                            }
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._.get(
                                                                    _vm.cmsData,
                                                                    "postcode"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "field-wrap"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "wrapper"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        form.postcode,
                                                                      expression:
                                                                        "form.postcode"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    id:
                                                                      "postcode",
                                                                    name:
                                                                      "postcode",
                                                                    type:
                                                                      "text",
                                                                    required:
                                                                      "required",
                                                                    maxLength:
                                                                      "100"
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      form.postcode
                                                                  },
                                                                  on: {
                                                                    input: [
                                                                      function(
                                                                        $event
                                                                      ) {
                                                                        if (
                                                                          $event
                                                                            .target
                                                                            .composing
                                                                        ) {
                                                                          return
                                                                        }
                                                                        _vm.$set(
                                                                          form,
                                                                          "postcode",
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      },
                                                                      function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onFormsChanged(
                                                                          "postcode_" +
                                                                            form.f_id,
                                                                          form.postcode,
                                                                          index
                                                                        )
                                                                      }
                                                                    ]
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("div", {
                                                          ref:
                                                            "postcode_" +
                                                            form.f_id,
                                                          refInFor: true,
                                                          staticClass: "hidden"
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.forms.length > 1
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "tls-passback-address-copy"
                                                      },
                                                      [
                                                        _c("p", [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                _vm._.get(
                                                                  _vm.cmsData,
                                                                  "copy_address_description"
                                                                )
                                                              ) +
                                                              "\n                                        "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        form.fixedDropdownStatusAsTrue
                                                          ? _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "tls-button-link-disable",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.CopyAddressPopup(
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._.get(
                                                                      _vm.cmsData,
                                                                      "copy_address"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "tls-button-link",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.CopyAddressPopup(
                                                                      index
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._.get(
                                                                      _vm.cmsData,
                                                                      "copy_address"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tls-popup-address-button" }, [
            _c("button", {
              staticClass: "tls-button-primary -uppercase",
              attrs: { type: "submit" },
              domProps: {
                textContent: _vm._s(_vm._.get(_vm.keywords, "confirm"))
              },
              on: { click: _vm.saveAllAddress }
            })
          ]),
          _vm._v(" "),
          _vm.showCopyAddressPopup
            ? _c("popup", {
                attrs: {
                  "popup-component-name": "simple-text",
                  "popup-title": _vm._.get(
                    _vm.cmsData,
                    "copy_address_popup_title"
                  ),
                  "popup-data": {
                    simpleText: _vm._.get(
                      _vm.cmsData,
                      "copy_address_popup_content"
                    )
                  }
                },
                on: {
                  "confirm-action": function($event) {
                    return _vm.copyAddress()
                  },
                  "cancel-action": function($event) {
                    _vm.showCopyAddressPopup = false
                  },
                  "close-action": function($event) {
                    _vm.showCopyAddressPopup = false
                  }
                }
              })
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }